export default function LocationSection() {
  return (
    <section id="location" className="w-full py-14 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <span className="text-xs font-black uppercase tracking-widest text-red-600 mb-2 block">
              Find Us
            </span>
            <h2 className="text-2xl md:text-3xl font-black text-gray-900 leading-tight">
              Visit Us in Buford, GA
            </h2>
            <p className="text-gray-500 text-sm mt-1">
              1040 Parkway Industrial Park Drive, Buford, GA 30518
            </p>
          </div>
          <a
            href="https://share.google/BAnWlIgXndMB6xxll"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white text-xs font-black uppercase tracking-widest px-5 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-sm"></i>
            </div>
            Get Directions
          </a>
        </div>

        {/* Map + Info grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Map embed */}
          <div className="lg:col-span-2 rounded-xl overflow-hidden border border-gray-100" style={{ height: "380px" }}>
            <iframe
              title="OneStopClearanceShop Location - Buford GA"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.0!2d-84.0!3d34.12!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5a1e1e1e1e1e1%3A0x1!2s1040+Parkway+Industrial+Park+Dr%2C+Buford%2C+GA+30518!5e0!3m2!1sen!2sus!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Info cards */}
          <div className="flex flex-col gap-4">
            {/* Address */}
            <div className="bg-gray-50 rounded-xl p-5 border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-2-line text-red-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-1">Address</p>
                  <p className="text-sm font-bold text-gray-900 leading-snug">
                    1040 Parkway Industrial Park Drive
                  </p>
                  <p className="text-sm text-gray-600">Buford, GA 30518</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-gray-50 rounded-xl p-5 border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                  <i className="ri-phone-line text-red-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-1">Call or Text</p>
                  <a
                    href="tel:678-936-5391"
                    className="text-sm font-bold text-gray-900 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    678-936-5391
                  </a>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-gray-50 rounded-xl p-5 border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-red-600 text-lg"></i>
                </div>
                <div className="w-full">
                  <p className="text-xs font-black uppercase tracking-widest text-gray-400 mb-2">Hours</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-bold text-red-600 bg-red-50 px-2 py-0.5 rounded-full">By Appointment Only</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-2 leading-relaxed">
                    Call or text to schedule your pickup. We'll get you in fast!
                  </p>
                </div>
              </div>
            </div>

            {/* Google Maps link */}
            <a
              href="https://share.google/BAnWlIgXndMB6xxll"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 border-2 border-gray-200 hover:border-red-500 hover:text-red-600 text-gray-500 text-xs font-black uppercase tracking-widest px-5 py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-google-fill text-sm"></i>
              </div>
              View on Google Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
